<div class="flex flex-column">
  <!-- selection of the reference dataset -->
  <div class="flex flex-row lg:flex-nowrap flex-wrap gap-2">
    <div class="w-12 lg:w-6">
      <p-panel
        header="Datasets configuration"
        [toggleable]="false"
        class="validation-row"
      >
        <ng-template pTemplate="icons">
          <label
            class="p-panel-header-icon mb-0"
            pTooltip="Select the spatial reference dataset from the menu below to access a list of validations available for comparison."
            tooltipPosition="bottom"
          >
            <span class="pi pi-question-circle help-icon"></span>
          </label>
        </ng-template>
        <p-accordion [multiple]="true" [value]="['spatialRef']">
          <p-accordion-panel value="spatialRef">
            <p-accordion-header>
              Spatial reference selection:
              {{
                selectedDatasetModel[0]?.datasetModel?.selectedDataset
                  ?.pretty_name || "-"
              }}
              /
              {{
                selectedDatasetModel[0]?.datasetModel?.selectedVersion
                  ?.pretty_name || "-"
              }}
            </p-accordion-header>

            <p-accordion-content>
              @if (selectedDatasetModel[0]?.datasetModel?.selectedDataset) {
                <qa-dataset
                  [removable]="false"
                  (changeDataset)="onDatasetChange()"
                  [selectionModel]="selectedDatasetModel[0].datasetModel"
                >
                </qa-dataset>
              }

              @if (datasetErrorSelector) {
                <div style="color: gray">
                  There was an error and no datasets could be fetched. Please
                  try again later.
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
        <!--  here selection of single or multiple non-reference validations. How to divide?  -->
        <div class="grid pt-2">
          <div class="col-12">
            <p-accordion [multiple]="true" [value]="['nonRef']">
              <p-accordion-panel value="nonRef">
                <p-accordion-header>
                  Non-reference datasets
                </p-accordion-header>

                <p-accordion-content>
                  <p-checkbox
                    inputId="multipleNonReference"
                    [(ngModel)]="multipleNonReference"
                    [binary]="true"
                    (click)="multipleNonReferenceChange()"
                  >
                  </p-checkbox>

                  <label for="multipleNonReference" class="ml-2">
                    Multiple non-reference datasets
                  </label>

                  <label
                    class="p-panel-header-icon"
                    pTooltip="Toggle to compare validations with 2 non-reference datasets"
                    tooltipPosition="bottom"
                  >
                    <span class="pi pi-question-circle ml-2"></span>
                  </label>
                </p-accordion-content>
              </p-accordion-panel>
            </p-accordion>
          </div>
        </div>
      </p-panel>
    </div>

    <!-- selection of the validations -->
    <div class="w-12 lg:w-6">
      <p-panel
        header="Validations selection"
        [toggleable]="false"
        class="validation-row"
      >
        <ng-template pTemplate="icons">
          <label
            class="p-panel-header-icon mb-0"
            pTooltip="You can choose as many as one or two validations from the list, according to the number of non-reference
                  datasets contained (respectively, two or one). Tip: rename your validations to find them more easily."
            tooltipPosition="bottom"
          >
            <span class="pi pi-question-circle help-icon"></span>
          </label>
        </ng-template>

        <p-accordion [multiple]="true" [value]="['validations']">
          <p-accordion-panel value="validations">
            <p-accordion-header>
              Validations available for comparison
            </p-accordion-header>

            <p-accordion-content>
              <div class="grid">
                <div class="col-12">
                  @if (!noValidationsError) {
                    <div class="p-float-label m-2">
                      <p-select
                        id="validationSelector"
                        [options]="validations4Comparison"
                        [(ngModel)]="selectedValidation"
                        optionLabel="comparison_label"
                        [style]="{ width: '100%' }"
                      >
                      </p-select>
                      @if (selectedDatasetModel[0]) {
                        <label for="validationSelector">
                          {{ selectValidationLabel }}
                        </label>
                      }
                    </div>
                  }
                  @if (noValidationsError) {
                    <div style="color: gray">
                      There was an error and validations could not be fetched.
                      Please try again later.
                    </div>
                  }
                </div>
              </div>

              <button
                pButton
                type="button"
                label="Add validation"
                icon="pi pi-plus-circle"
                (click)="addValidation2Comparison()"
                class="p-button-success mt-2 mb-2"
                style="padding: 0.2rem"
                [disabled]="addValidationButtonDisabled()"
              ></button>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>

        @for (item of comparisonModel.selectedValidations; track item) {
          <button
            pButton
            type="button"
            (click)="removeValidation(item)"
            [label]="'Remove: ' + item.comparison_label"
            icon="pi pi-trash"
            class="p-button-danger mt-2"
            style="padding: 0.2rem"
          ></button>
        }
      </p-panel>
    </div>
  </div>

  <!-- selection of the spatial extent -->
  <div class="w-12 py-2">
    <p-panel header="Spatial extent" [toggleable]="true" class="validation-row">
      <ng-template pTemplate="icons">
        <label
          class="p-panel-header-icon"
          pTooltip="When the selected validations are partially overlapping, all or only common points can be selected."
          tooltipPosition="bottom"
        >
          <span class="pi pi-question-circle"></span>
        </label>
      </ng-template>
      <div class="grid">
        <div class="col-12">
          <qa-spatial-extent
            [extentModel]="this.spatialExtent"
            [disabled]="this.spatialExtentDisabled()"
            (ifChecked)="unionChecked($event)"
          />
        </div>
      </div>
    </p-panel>
  </div>
</div>

<!-- Start comparison button -->
<div class="w-12">
  <div>
    <div class="d-flex justify-content-center text-2xl">
      <p-button
        id="compareButton"
        label="Compare"
        icon="pi pi-arrows-h"
        (onClick)="startComparison()"
      ></p-button>
    </div>
  </div>
</div>
